import LegalShell from '@/components/LegalShell';

export default function PrivacyPage() {
  return (
    <LegalShell eyebrow="Legal" title="Privacy Policy." lastUpdated="April 2026">
      <div data-testid="privacy-page" className="space-y-6 text-foreground/85 leading-relaxed">
        <p>
          Radiance Hub (“we”, “us”) respects your privacy. This policy explains what we collect, why,
          and your choices. Operator: Radiance Hub Team, Mumbai, Maharashtra, India.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">1. Information we collect</h2>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><strong>Account data:</strong> name, email address, hashed password.</li>
          <li><strong>Profile data:</strong> skin type, concerns, region, lifestyle preferences (optional).</li>
          <li><strong>Usage data:</strong> pages visited, feature usage, AI credit activity, device/browser info.</li>
          <li><strong>AI inputs:</strong> questions you ask, images you upload for styling. Images are sent to our AI vendor for analysis and are not stored as files once the analysis completes.</li>
          <li><strong>Payment data:</strong> payment IDs and order IDs returned by Razorpay. We do not store card numbers.</li>
        </ul>

        <h2 className="font-display text-2xl text-ink mt-8">2. How we use information</h2>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>To provide and personalize the Service;</li>
          <li>To process credit purchases and maintain ledger entries;</li>
          <li>To respond to support requests;</li>
          <li>To detect abuse, fraud or violations of our Terms;</li>
          <li>To improve the Service (aggregated, non-identifying analytics).</li>
        </ul>

        <h2 className="font-display text-2xl text-ink mt-8">3. Sharing</h2>
        <p>
          We share data only with the vendors required to operate the Service:
        </p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><strong>Razorpay</strong> — payment processing.</li>
          <li><strong>Google Gemini (via Emergent)</strong> — AI text &amp; image analysis.</li>
          <li><strong>Open-Meteo</strong> — public weather data (no personal data shared).</li>
          <li><strong>PostHog</strong> — product analytics (pseudonymized).</li>
        </ul>
        <p>We do not sell your personal information.</p>

        <h2 className="font-display text-2xl text-ink mt-8">4. Data retention</h2>
        <p>
          Account and profile data are retained for as long as your account is active. Payment ledger
          entries may be retained for up to 7 years to satisfy Indian tax and accounting requirements.
          Uploaded styling photos are not stored after analysis completes. You can request deletion at
          any time by writing to{' '}
          <a className="underline underline-offset-4" href="mailto:Webuser@radiancehub.org">Webuser@radiancehub.org</a>.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">5. Security</h2>
        <p>
          We use industry standard practices: HTTPS in transit, bcrypt password hashing, JWT access
          tokens, scoped credentials for third-party vendors and least-privilege infrastructure access.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">6. Your rights</h2>
        <p>
          Subject to applicable law, you may request access, correction, deletion or export of your
          personal data. Email{' '}
          <a className="underline underline-offset-4" href="mailto:Webuser@radiancehub.org">Webuser@radiancehub.org</a>.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">7. Children</h2>
        <p>
          The Service is not directed to children under 18. We do not knowingly collect personal data
          from minors; if you believe we have, contact us and we will delete it.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">8. Cookies</h2>
        <p>
          We use essential cookies/local-storage for authentication and a limited set of analytics
          cookies (via PostHog) to improve the Service. You can disable cookies in your browser; some
          features may not work without them.
        </p>

        <h2 className="font-display text-2xl text-ink mt-8">9. Changes</h2>
        <p>
          We may update this policy occasionally. Material changes will be notified via email or in-app.
        </p>
      </div>
    </LegalShell>
  );
}
